import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14af019f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "base-title-bulk-button" }
const _hoisted_3 = ["tabindex"]
const _hoisted_4 = ["tabindex"]
const _hoisted_5 = ["tabindex"]
const _hoisted_6 = ["tabindex"]
const _hoisted_7 = ["tabindex"]
const _hoisted_8 = {
  key: 1,
  class: "base-title-button"
}
const _hoisted_9 = ["tabindex"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "download_for_offline", -1))
const _hoisted_11 = {
  key: 2,
  class: "base-title-button"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "input_circle", -1))
const _hoisted_13 = { class: "row gx-5" }
const _hoisted_14 = { class: "col-4 col-xl-3 sidebar" }
const _hoisted_15 = { class: "col-8 col-xl-9 overview" }
const _hoisted_16 = { class: "row row-list gx-5" }
const _hoisted_17 = { class: "col" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-2 mb-5" }, "   ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_accordion_header = _resolveComponent("base-accordion-header")!
  const _component_base_accordion_collapse = _resolveComponent("base-accordion-collapse")!
  const _component_base_accordion_item = _resolveComponent("base-accordion-item")!
  const _component_base_accordion = _resolveComponent("base-accordion")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_BaseTitle = _resolveComponent("BaseTitle")!
  const _component_AlertError2 = _resolveComponent("AlertError2")!
  const _component_OverviewCriteria = _resolveComponent("OverviewCriteria")!
  const _component_OverviewLegend = _resolveComponent("OverviewLegend")!
  const _component_OverviewTable = _resolveComponent("OverviewTable")!
  const _component_OverviewControls = _resolveComponent("OverviewControls")!
  const _component_base_container = _resolveComponent("base-container")!
  const _component_CatalogBuildStatus = _resolveComponent("CatalogBuildStatus")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_base_container, { "container-fluid": "" }, {
      default: _withCtx(() => [
        _createVNode(_component_BaseTitle, {
          title: _ctx.$t('products'),
          mb: 2,
          "show-refresh-button": "",
          "back-route": _ctx.goBackRoute,
          "help-text": _ctx.$t('descriptionProductOrderProductLevel'),
          onRefresh: _ctx.reloadContent
        }, {
          buttons: _withCtx(() => [
            (_ctx.AbilityContext.isAuthorizedForFeature('MGMT_CUSTOMER_CATALOG_PRODUCTS'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createVNode(_component_base_accordion, {
                    id: "bulkActionsAccordion",
                    class: _normalizeClass(["d-inline-block", { 'criteria-changed-disabled': _ctx.criteriaChanged }])
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_base_accordion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_base_accordion_header, {
                            id: "bulkActionsHeader",
                            target: "bulkActionsCollapse",
                            "is-open": _ctx.isBulkActionsOpen && !_ctx.criteriaChanged,
                            class: _normalizeClass(["action-header", { 'disabled': _ctx.criteriaChanged }])
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('actions')), 1)
                            ]),
                            _: 1
                          }, 8, ["is-open", "class"]),
                          _createVNode(_component_base_accordion_collapse, {
                            id: "bulkActionsCollapse",
                            "label-id": "bulkActionsHeader",
                            "parent-id": "bulkActionsAccordion",
                            "is-open": _ctx.isBulkActionsOpen && !_ctx.criteriaChanged
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_2, [
                                _createElementVNode("a", {
                                  href: "javascript:void(0)",
                                  class: _normalizeClass(["btn btn-hover d-block mb-2", { 'disabled': _ctx.criteriaChanged }]),
                                  tabindex: _ctx.criteriaChanged ? -1 : 0,
                                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.criteriaChanged ? null : _ctx.confirmBulkClearCustomSortWeights()), ["prevent"]))
                                }, [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('bulkClearCustomSortWeights')), 1)
                                ], 10, _hoisted_3),
                                _createElementVNode("a", {
                                  href: "javascript:void(0)",
                                  class: _normalizeClass(["btn btn-hover d-block mb-2", { 'disabled': _ctx.criteriaChanged }]),
                                  tabindex: _ctx.criteriaChanged ? -1 : 0,
                                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.criteriaChanged ? null : _ctx.confirmBulkClearCustomPrices()), ["prevent"]))
                                }, [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('bulkClearCustomPrices')), 1)
                                ], 10, _hoisted_4),
                                _createElementVNode("a", {
                                  href: "javascript:void(0)",
                                  class: _normalizeClass(["btn btn-hover d-block mb-2", { 'disabled': _ctx.criteriaChanged }]),
                                  tabindex: _ctx.criteriaChanged ? -1 : 0,
                                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.criteriaChanged ? null : _ctx.confirmBulkClearCustomNamesNl()), ["prevent"]))
                                }, [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('bulkClearCustomNamesNl')), 1)
                                ], 10, _hoisted_5),
                                _createElementVNode("a", {
                                  href: "javascript:void(0)",
                                  class: _normalizeClass(["btn btn-hover d-block", { 'disabled': _ctx.criteriaChanged }]),
                                  tabindex: _ctx.criteriaChanged ? -1 : 0,
                                  onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.criteriaChanged ? null : _ctx.confirmBulkClearCustomNamesFr()), ["prevent"]))
                                }, [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('bulkClearCustomNamesFr')), 1)
                                ], 10, _hoisted_6),
                                _createElementVNode("a", {
                                  href: "javascript:void(0)",
                                  class: _normalizeClass(["btn btn-hover d-block", { 'disabled': _ctx.criteriaChanged }]),
                                  tabindex: _ctx.criteriaChanged ? -1 : 0,
                                  onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.criteriaChanged ? null : _ctx.showImportHistory()), ["prevent"]))
                                }, [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('showImportHistory')), 1)
                                ], 10, _hoisted_7)
                              ])
                            ]),
                            _: 1
                          }, 8, ["is-open"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["class"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.AbilityContext.isAuthorizedForFeature('EXPORT_CATALOG_PRODUCT_DETAILS'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("a", {
                    href: "javascript:void(0)",
                    class: _normalizeClass(["btn btn-hover btn-outline-primary icon-link", { 'disabled': _ctx.criteriaChanged }]),
                    tabindex: _ctx.criteriaChanged ? -1 : 0,
                    onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.criteriaChanged ? null : _ctx.confirmExport()), ["prevent"]))
                  }, [
                    _hoisted_10,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('export')), 1)
                  ], 10, _hoisted_9)
                ]))
              : _createCommentVNode("", true),
            (_ctx.AbilityContext.isAuthorizedForFeature('UPLOAD_PRODUCT_CUSTOMER_OVERRIDES'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(_component_router_link, {
                    to: {name: 'import-products'},
                    class: "btn btn-hover icon-link"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_12,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('import')), 1)
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["title", "back-route", "help-text", "onRefresh"]),
        _createVNode(_component_AlertError2, {
          error: _ctx.productsOverviewUI.getError()
        }, null, 8, ["error"]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_OverviewCriteria, {
              onReloadedContent: _ctx.onCriteriaInitialized,
              onSubmit: _ctx.reloadContent,
              onCriteriaChanged: _ctx.onCriteriaChanged
            }, null, 8, ["onReloadedContent", "onSubmit", "onCriteriaChanged"]),
            _createVNode(_component_OverviewLegend, {
              "is-for-pharmacist": "",
              class: "mt-4"
            })
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_OverviewTable, {
                  "products-overview": _ctx.productsOverview,
                  "has-products": _ctx.hasProducts,
                  onlyProductsWithCustomWeights: _ctx.isCustomSortWeightsChecked,
                  ui: _ctx.productsOverviewUI,
                  onDataChanged: _ctx.reloadContent
                }, null, 8, ["products-overview", "has-products", "onlyProductsWithCustomWeights", "ui", "onDataChanged"]),
                _createVNode(_component_OverviewControls, {
                  "products-overview": _ctx.productsOverview,
                  "has-products": _ctx.hasProducts,
                  "is-layout-toggle-supported": false,
                  "is-csv-download-supported": false,
                  class: "mt-3",
                  onChange: _ctx.onControlsChanged
                }, null, 8, ["products-overview", "has-products", "onChange"])
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _hoisted_18,
    _createVNode(_component_CatalogBuildStatus)
  ], 64))
}